import Spektrix from './classes/Spektrix'
import alert from './alert'
import format from 'date-fns/format'
import helpers from './helpers'

jQuery(document).ready(function () {
  const spektrix = new Spektrix()

  // Keep the session alive by pinging a request every 5 minutes
  setInterval(function () {
    spektrix.get('basket')
      .then(function (response) {
        console.info('Basket Session: ' + response.status)
      })
  }, 60 * 5000)

  // Fade out the basket message.
  $('.basket-flash-message').delay(5000).fadeOut('slow')

  $('#car_park_voucher').on('click', function () {
    const quantity = $('#parking-vouchers input[name=car_park_voucher]').val()
    const stockItemID = $('#parking-vouchers input[name=car_park_voucher]').data('stock-item')
    if (quantity === 'none') {
      return
    }

    const payload = []
    for (let i = 0; i < parseInt(quantity); i++) {
      payload.push({
        stockItem: stockItemID
      })
    }
    spektrix.post('basket/merchandise', { body: payload })
      .then(function (response) {
        if (response.ok) {
          $('#car_park_voucher').html('Added')
          $('#car_park_voucher').prop('disabled', true)
          window.BASKET.refresh()
        } else {
          alert.errorHandler('<p class="error-message">An error occured trying to book your parking vouchers</p>')
        }
      })
  })

  // Bind to document and watch for appropriate classes since this is
  // generaeted dynamically and is not yet part of the DOM
  $(document).on('click', '.ticket .ticket-remove', function () {
    const ticketIds = $(this).data('ticket-ids')
    const previousText = $(this).text()
    $(this).html(helpers.loadingButton())

    spektrix.delete('basket/tickets', { rawParams: '?ticketIds=' + ticketIds.join(',') }).then((res) => {
      if (res.ok) {
        window.BASKET.refresh()
      } else {
        $(this).html(previousText)
        alert.errorHandler('<p class="error-message">An error occured when trying to remove your tickets from the basket</p>')
      }
    })
  })

  $(document).on('click', '.merchandise .merchandise-remove', function () {
    const merchandiseItemIds = $(this).data('merchandise-ids')
    const previousText = $(this).text()
    $(this).html(helpers.loadingButton())

    spektrix.delete('/basket/merchandise', { rawParams: '?merchandiseItemIds=' + merchandiseItemIds.join(',') }).then((res) => {
      if (res.ok) {
        window.BASKET.refresh()
      } else {
        $(this).html(previousText)
        alert.errorHandler('An error occured when trying to remove your tickets from the basket')
      }
    })
  })

  function footerText (tickets, operas) {
    const length = typeof operas.length === 'number' ? operas.length : 0
    const pluralise = () => {
      return length > 1 ? 's' : ''
    }
    const subtotal = tickets.reduce((total, ticket) => {
      return total + ticket.total
    }, 0)

    return `${length} opera${pluralise()} added ( ${subtotal.toLocaleString(undefined, { style: 'currency', currency: 'GBP' })} )`
  }

  function ticketTemplate (instances, quantity) {
    const ticketIds = []
    const ticketPlans = {}

    for (const instance of instances) {
      ticketIds.push(instance.id)
      if (ticketPlans[instance.planName]) {
        ticketPlans[instance.planName].quantity += 1
      } else {
        ticketPlans[instance.planName] = {
          quantity: 1,
          price: instance.total
        }
      }
    }

    let ticketCombinationDom = ''
    let totalPrice = 0
    for (const plan in ticketPlans) {
      ticketCombinationDom += `${ticketPlans[plan].quantity} x ${plan} <br />`
      totalPrice += ticketPlans[plan].quantity * ticketPlans[plan].price
    }

    return `<div class="ticket c-event-basket__item">
    <h3>${instances[0].event.name}</h3>
    <p>
        ${format(instances[0].instance.start, 'dddd D MMM YYYY HH:mm')}<br />
        ${ticketCombinationDom}
    </p>
    <button class="ticket-remove c-btn c-btn--small c-btn--black" data-ticket-ids='${JSON.stringify(ticketIds)}'>Remove</button>
    <div class="total">
        Subtotal: <strong>${(totalPrice).toLocaleString(undefined, { style: 'currency', currency: 'GBP' })}</strong>
    </div>
</div>`
  }

  function parkingTemplate (merchandise) {
    const parkingVouchers = merchandise.filter(m => m.stockItem.id === $('.basket #parking-vouchers select[name=car_park_voucher]').data('stock-item'))

    if (parkingVouchers.length === 0) {
      return
    }

    return `<div class="merchandise c-event-basket__item">
    <h3>Car Park Vouchers</h3>
    <p>
        ${parkingVouchers.length} x ${parkingVouchers[0].total.toLocaleString(undefined, { style: 'currency', currency: 'GBP' })}
    </p>
    <button class="merchandise-remove c-btn c-btn--small c-btn--black" data-merchandise-ids='${JSON.stringify(parkingVouchers.map(p => p.id))}'>Remove</button>
    <div class="total">
        Subtotal: <strong>${(parkingVouchers[0].total * parkingVouchers.length).toLocaleString(undefined, { style: 'currency', currency: 'GBP' })}</strong>
    </div>
</div>`
  }

  function showPackageView (bool, operas) {
    if (bool === true) {
      $('#build-package').show()
      $('#basket-footer').show()
      $('#empty-basket').hide()
      $('.c-page-events').addClass('push-up')
      if (operas.length >= 3) {
        $('.c-btn__build').show()
      }
    } else {
      $('#build-package').hide()
      $('#parking-vouchers').hide()
      $('#basket-footer').hide()
      $('#empty-basket').show()
      $('.c-page-events').removeClass('push-up')
    }

    // Hide loading
    $('.c-loading').hide()
    $('.c-event-wrapper').show()
    $('.c-event-wrapper').addClass('fadeIn')
  }

  /**
   * Appends a class to instances or operas that have been selected
   * @param {Array<string>} operas An array of operas
   */
  function styleSelectedInstance (operas) {
    $('.c-event-list__item').each(function () {
      const $instances = $(this).find('.c-page-events-list__item .booking-form')
      let eventIsSelected = false

      $instances.each(function () {
        const instanceName = $(this).data('name')

        if (operas.indexOf(instanceName) !== -1) {
          $(this).closest('.c-page-events-list__item').addClass('item-selected')
          eventIsSelected = true
        } else {
          $(this).closest('.c-page-events-list__item').removeClass('item-selected')
        }
      })

      $(this).toggleClass('c-event-list__item_selected', eventIsSelected)

      if (!eventIsSelected) {
        $(this).find('.c-page-events__cta .c-btn').html('Select <i class="fa fa-chevron-down" aria-hidden="true"></i>')
      }
    })
  }

  $('.instance-expand').click(function (e) {
    $(this).toggleClass('active')
    $(this).closest('.c-page-events-list__item').find('.booking-form').slideToggle()
    $(this).closest('.c-btn')
      .find('.fa')
      .toggleClass('fa-chevron-up')
      .toggleClass('fa-chevron-down')
  })

  $('.instance-form-expand').click(function () {
    $(this).toggleClass('active')
    $(this).closest('.c-page-instance__list').find('.booking-wrapper').slideToggle()
  })

  function membershipTemplate (membership) {
    spektrix.get('basket/membership-subscriptions/' + membership.id, {})
      .then((data) => {
        if (data.ok) {

        } else {
          alert.errorHandler('<p class="error-message">Membership price unavailable.</p>')
        }
      })

    return `<div class="merchandise c-event-basket__item">
        <h3>${membership.membership.name}</h3>
        <p>
        </p>
        <div class="total">
          Total: <strong>${(membership.price).toLocaleString(undefined, { style: 'currency', currency: 'GBP' })}</strong>
        </div>
    </div>`
  }

  function checkForParkingVoucher (merchandise) {
    for (const i in merchandise) {
      if (merchandise[i].stockItem.id === '8401ACDNQDNDVRQCTJQRQPHVTKLNTCVJH') {
        return true
      }
    }
    return false
  }

  window.BASKET = {
    data: {},
    refresh: function () {
      spektrix.get('basket', { params: { $expand: 2 } })
        .then((response) => {
          if (!response.ok) {
            alert.errorHandler('An error occured when trying to retrieve your basket')
          }

          return response.json()
        })
        .then((data) => {
          window.BASKET.data = data
          const tickets = data.tickets

          if (data.membershipSubscriptions.length > 0) {
            for (const i in data.membershipSubscriptions) {
              $('#basket-memberships').html(membershipTemplate(data.membershipSubscriptions[i]))
            }
          }

          if (tickets) {
            // Build up a list of instances that tickets belong to
            // End result is a map where each key is the instance tickets have been selected for
            const ticketViewModel = data.tickets.reduce((acc, ticket) => {
              if (acc[ticket.instance.id] && acc[ticket.instance.id].length > 0) {
                acc[ticket.instance.id].push(ticket)
              } else {
                acc[ticket.instance.id] = [ticket]
              }
              return acc
            }, {})

            const bookedOperaNames = Object.keys(ticketViewModel).map(i => ticketViewModel[i][0]['event']['name'])
            const bookedOperaIds = Object.keys(ticketViewModel)
            const ticketHtml = bookedOperaIds.reduce((html, instance) => {
              return html + ticketTemplate(ticketViewModel[instance], ticketViewModel[instance].length)
            }, '')

            // Only allow a package to be built when 3 operas are present
            if (bookedOperaIds.length >= 3) {
              $('#build-package a').show()
              $('#build-package p').hide()
            } else if (bookedOperaIds.length === 2) {
              $('#build-package a').hide()
              $('#build-package p').html(`Add 1 more opera to your package to checkout`)
            } else {
              $('#build-package a').hide()
              $('#build-package p').html(`Add ${3 - bookedOperaIds.length} or more operas to your package to checkout`)
            }

            $('.basket #basket-tickets').html(ticketHtml)
            $('.c-basket-footer--text').html(footerText(data.tickets, bookedOperaNames))
            styleSelectedInstance(bookedOperaNames)

            // Generate the parking markup
            if (data.merchandiseItems.length > 0) {
              $('.basket #basket-merchandise').html(parkingTemplate(data.merchandiseItems))
              if (checkForParkingVoucher(data.merchandiseItems)) {
                $('#parking-vouchers').show()
                //
                $('#car_park_voucher').html('Added')
                $('#car_park_voucher').prop('disabled', true)
              } else {
                $('#parking-vouchers').hide()
              }
            } else {
              $('.basket #basket-merchandise').html('')
              if (bookedOperaIds.length >= 3) {
                $('#parking-vouchers').show()
              }
            }

            showPackageView(true, bookedOperaIds)
          } else {
            $('.basket #basket-tickets').html('')
            $('.basket #basket-merchandise').html('')
            showPackageView(false, [])
          }
        })
    }
  }

  window.BASKET.refresh()
})



// WEBPACK FOOTER //
// ./resources/assets/js/basket.js